import {onFind} from "@elements/init-modules-in-scope";
import {on, findIn, findAllIn, addClass, removeClass} from "@elements/dom-utils";

const selectors = {
    table: '.js-scrolling-table',
    tableBody: '.js-scrolling-table__body',
    tableButtonNext: '.js-scrolling-table__btn-next',
    tableButtonPrev: '.js-scrolling-table__btn-prev',
};

export function init() {
    onFind(selectors.table, function (baseElement) {
        let scrollContainer = findIn(selectors.tableBody, baseElement);
        let scrollButtonNext = findIn(selectors.tableButtonNext, baseElement);
        let scrollButtonPrev = findIn(selectors.tableButtonPrev, baseElement);
        let scrollWidth = findIn("td", baseElement);
        let countRows = findAllIn("tr", baseElement);
        scrollWidth = scrollWidth.offsetWidth;
        let scrollContainerWidth = countRows.length * scrollWidth;
        console.log(scrollContainerWidth);

        on('click', function (e) {
            if((scrollContainerWidth - scrollContainer.offsetWidth - scrollContainer.scrollLeft - scrollWidth) != 0) {
                scrollContainer.scrollLeft += scrollWidth;
            } else {
                addClass("d-none", scrollButtonNext);
                removeClass("d-none", scrollButtonPrev);
            }
        }, scrollButtonNext);

        on('click', function (e) {
                if((scrollContainer.offsetWidth + scrollContainer.scrollLeft) != scrollContainer.offsetWidth) {
                    scrollContainer.scrollLeft -= scrollWidth;
                } else {
                    addClass("d-none", scrollButtonPrev);
                    removeClass("d-none", scrollButtonNext);
                }

        }, scrollButtonPrev);
    });
}